export default __webpack_public_path__ + "static/Row 5.2_CWA-f6667abfcac627f4080fe6b61ec3997c.jpg";